import { createSlice } from '@reduxjs/toolkit'
import {
  fetchViolationsEnforcementsGroupedByViolationAsync,
  fetchViolationsEnforcementsGroupedByViolationAsyncBuilder,
} from './asyncRequests'

export interface IViolationEnforcementState {
  groupedEnforcementsByViolation: {
    loading: boolean
    error: string
    data: any[]
  }
}

const initialState: IViolationEnforcementState = {
  groupedEnforcementsByViolation: {
    loading: false,
    error: '',
    data: [],
  },
}

export const ViolationEnforcementSlice = createSlice({
  name: 'violationSlice',
  initialState,
  reducers: {
    resetGroupedEnforcements: (state, action) => {
      state.groupedEnforcementsByViolation =
        initialState.groupedEnforcementsByViolation
    },
  },
  extraReducers: (builder) => {
    fetchViolationsEnforcementsGroupedByViolationAsyncBuilder(builder)
  },
})

export const ViolationEnforcementActions = {
  ...ViolationEnforcementSlice.actions,
  fetchViolationsEnforcementsGroupedByViolationAsync
}

export const ViolationEnforcementReducer = ViolationEnforcementSlice.reducer
